export default __webpack_public_path__ + "static/g-profile-a31d6b226acc6ab9a890973483f0ee30.jpg";